/**
 * Deposit Page interactions
 */

document.addEventListener('DOMContentLoaded', function() {
  var methodButtons = document.querySelectorAll('.deposit-method[data-method]');
  var detailPanels = document.querySelectorAll('.deposit-details[data-details]');

  if (!methodButtons.length || !detailPanels.length) return;

  methodButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      var method = button.getAttribute('data-method');

      methodButtons.forEach(function(btn) {
        btn.classList.toggle('is-active', btn === button);
      });

      detailPanels.forEach(function(panel) {
        var isMatch = panel.getAttribute('data-details') === method;
        panel.classList.toggle('is-active', isMatch);
      });
    });
  });
});
